import { render } from "./epidemicManage.vue?vue&type=template&id=9630792a&scoped=true&ts=true"
import script from "./epidemicManage.vue?vue&type=script&lang=ts"
export * from "./epidemicManage.vue?vue&type=script&lang=ts"

import "./epidemicManage.vue?vue&type=style&index=0&id=9630792a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9630792a"]])

export default __exports__